import { ChangeEvent, useEffect, useRef, useState } from "react";
import { handleUploadFiles } from "../../../../services/Api/requestService";
import Delete from "../../../../assets/icons/x.svg";
import { usePartnerRequestsStore2 } from "../../../../stores/Cac/Partner/partnerRequests";
import SelectCategories from "../Utils/SelectCategories";
import SelectDate from "../Utils/SelectDate";
import { useUtilsStore } from "../../../../stores/Utils/selects";
import {
  createRequest,
  getUsersCustomerToMission,
} from "../../../../services/Api/customerService";
import { useParams } from "react-router-dom";
import {
  showToastError,
  showToastSuccess,
} from "../../../../services/Toasts/toasts";
import { ToastContainer } from "react-toastify";

const ModalCreateRequest = () => {
  // Store
  const {
    choiceModal,
    setChoiceModal,
    usersMissionAssign,
    setUsersMissionAssign,
    checkboxValues,
    setCheckboxValues,
    dataRequest,
    setDataRequest,
    comment,
    setComment,
    updateRequest,
    setUpdateRequest,
    resetRequest,
  } = usePartnerRequestsStore2();
  const { idCustomer, idMission } = useParams();
  const { startDate, setStartDate } = useUtilsStore();

  // States
  const [compteur, setCompteur] = useState(255);
  const [uploadedFiles, setUploadedFiles] = useState<any>([]);

  useEffect(() => {
    if (idCustomer) {
      getUsersCustomerToMission(parseInt(idCustomer), idMission)
        .then((users) => {
          setUsersMissionAssign(users);
          if (users?.length === 0) {
            return;
          }
          console.log(users);

          const clientCheckboxValues: { [key: number]: boolean } = {};
          users.forEach((user: any) => {
            clientCheckboxValues[user.id] = true;
          });
          setCheckboxValues(clientCheckboxValues);
        })
        .catch(() => showToastError("Une erreur s'est produite"));
      }
  }, [idMission]);

  const textAreaRef = useRef(null);

  // This is for block commentary input when compteur is 0
  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    let nouveauTexte = e.target.value;
    if (nouveauTexte.length > 255) {
      nouveauTexte = comment;
    }
    const nouveauCompteur = 255 - nouveauTexte.length;
    setComment(nouveauTexte);
    setCompteur(nouveauCompteur);
    setDataRequest({
      ...dataRequest,
      description: nouveauTexte,
    });
  };

  const handleReset = () => {
    setComment("");
    setChoiceModal("");
    setCompteur(255);
    setCheckboxValues({});
    setStartDate(null);
    setDataRequest({
      ...dataRequest,
      description: "",
      categoryId: 0,
    });
  };

  const handleCreateRequest = async () => {
    try {
      if (startDate === null)
        return showToastError("Veuillez sélectionner une date");
      if (dataRequest.categoryId === 0)
        return showToastError("Veuillez sélectionner une catégorie");

      const dataForSend = {
        description: dataRequest.description,
        categoryId: dataRequest.categoryId,
        dueDate: dataRequest.dueDate,
        customerUsers: Object.entries(checkboxValues)
          .filter(([_, value]) => value)
          .map(([key]) => Number(key)),
      };

      // Crée la requête
      const docRequestResponse = await createRequest(
        Number(idCustomer),
        Number(idMission),
        dataForSend
      );

      let requestId: number;
      if (docRequestResponse) {
        requestId = parseInt(docRequestResponse);

        // Upload les fichiers une fois que requestId est disponible
        if (uploadedFiles && uploadedFiles.length > 0) {
          await handleUploadFiles(requestId, uploadedFiles);
        }
      }
      if (docRequestResponse) {
        resetRequest();
        setUpdateRequest(!updateRequest);
        handleReset();
        setStartDate(null);
        showToastSuccess("La requête a bien été créée !");
      }
    } catch (error) {
      handleReset();
      showToastError("Erreur lors de la création de la requête");
    }
  };

  // Function to handle file upload
  const handleFileEvent = (e: any) => {
    const choosenFile = Array.prototype.slice.call(e.target.files);
    setUploadedFiles(choosenFile);
  };

  // Function to delete a file
  const deleteFile = (fileToDelete: any) => {
    const newFiles = uploadedFiles?.filter(
      (file: any) => file !== fileToDelete
    );
    setUploadedFiles(newFiles);
  };

  const handleCheckboxChange = (value: number, checked: boolean) => {
    setCheckboxValues({ ...checkboxValues, [value]: checked });
  };

  return (
    choiceModal == "create" && (
      <>
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-hidden p-2 font-BarlowCondensed outline-hidden focus:outline-hidden sm:p-5">
          <div className="relative m-auto w-full max-w-4xl">
            {/*content*/}
            <div className="relative flex max-h-[calc(100dvh-1rem)] w-full flex-col overflow-hidden rounded-2xl border-0 bg-gradient-to-br from-slate-50 to-blue-50 shadow-2xl outline-hidden focus:outline-hidden sm:max-h-[90dvh]">
              {/*body*/}
              <ToastContainer position="bottom-right" />
              <div className="flex min-h-0 w-full flex-col items-center justify-start overflow-y-auto p-2 sm:p-3">
                {/* Configuration de la requête */}
                <div className="w-full bg-white rounded-2xl shadow-lg border border-gray-100 p-3 mb-3">
                  <h4 className="text-base font-semibold text-gray-700 mb-3 flex items-center gap-2">
                    <svg className="w-4 h-4 text-yellow-trio" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                    Configuration de la requête
                  </h4>
                  <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="flex flex-col">
                      <SelectCategories />
                    </div>
                    <div className="flex flex-col">
                      <SelectDate />
                    </div>
                  </div>
                </div>

                {/* Gestion des utilisateurs et description */}
                <div className="w-full bg-white rounded-2xl shadow-lg border border-gray-100 p-3 mb-3">
                  <h4 className="text-base font-semibold text-gray-700 mb-3 flex items-center gap-2">
                    <svg className="w-4 h-4 text-yellow-trio" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                    Détails de la requête
                  </h4>
                  
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    {/* Utilisateurs affectés */}
                    <div className="bg-gray-50 rounded-xl p-3 border border-gray-200">
                      <div className="flex items-center gap-2 mb-2">
                        <div className="p-1.5 bg-blue-100 rounded-lg">
                          <svg className="w-3.5 h-3.5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                          </svg>
                        </div>
                        <h5 className="font-semibold text-gray-700 text-sm">Utilisateurs affectés</h5>
                      </div>
                      
                      <div className="w-full bg-white border border-gray-200 rounded-lg m-auto h-48 overflow-y-auto shadow-sm">
                        {usersMissionAssign.length > 0 ? (
                          usersMissionAssign?.map((user) => (
                            <div
                              key={user?.id}
                              className="flex items-center p-2 border-b border-gray-100 hover:bg-blue-50 transition-colors duration-150"
                            >
                              <input
                                type="checkbox"
                                checked={checkboxValues[user?.id] || false}
                                onChange={() => {
                                  handleCheckboxChange(
                                    user?.id,
                                    !checkboxValues[user?.id]
                                  );
                                }}
                                className="mr-2 w-3.5 h-3.5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                              />
                              <div className="flex flex-col">
                                <span className="text-xs font-medium text-gray-700">{user?.fullName}</span>
                                <span className="text-xs text-gray-500">{user?.eMail}</span>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="flex items-center justify-center h-full">
                            <p className="text-gray-500 text-sm italic">Aucun utilisateur</p>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Description et documents */}
                    <div className="bg-gray-50 rounded-xl p-3 border border-gray-200">
                      <div className="flex items-center gap-2 mb-2">
                        <div className="p-1.5 bg-green-100 rounded-lg">
                          <svg className="w-3.5 h-3.5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                          </svg>
                        </div>
                        <h5 className="font-semibold text-gray-700 text-sm">Description et documents</h5>
                      </div>

                      <div className="w-full bg-white border border-gray-200 rounded-lg p-3 h-48 flex flex-col">
                        <div className="flex flex-col gap-2 mb-2">
                          <div>
                            <label className="block text-xs font-medium text-gray-700 mb-1">Description</label>
                            <textarea
                              name="comment"
                              placeholder="Ajoutez une description"
                              value={comment}
                              onChange={handleChange}
                              ref={textAreaRef}
                              id="comment"
                              style={{ resize: "none" }}
                              className="w-full rounded-lg border border-gray-300 h-16 text-left p-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-150"
                            />
                            <div className="w-full flex justify-end items-end pt-1">
                              <p className="text-gray-400 text-xs">
                                {compteur} caractère(s) restant(s)
                              </p>
                            </div>
                          </div>
                          
                          <div>
                            <label className="block text-xs font-medium text-gray-700 mb-1">Documents</label>
                            <input
                              type="file"
                              name="doc"
                              id="fileUpload"
                              multiple
                              onChange={handleFileEvent}
                              className="w-full text-xs text-gray-500 file:mr-4 file:py-1 file:px-3 file:rounded-lg file:border-0 file:text-xs file:font-medium file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 transition-colors duration-150"
                            />
                          </div>
                        </div>
                        
                        {/* Liste des fichiers uploadés */}
                        {uploadedFiles?.length > 0 && (
                          <div className="flex-1 overflow-y-auto">
                            <div className="p-2 bg-blue-50 rounded-lg border border-blue-200 h-full">
                              <p className="text-xs font-medium text-blue-800 mb-2 sticky top-0 bg-blue-50 py-1">Fichiers sélectionnés :</p>
                              <div className="space-y-1 max-h-20 overflow-y-auto">
                                {uploadedFiles?.map((file: any, index: any) => (
                                  <div className="flex items-center justify-between text-xs p-1 hover:bg-blue-100 rounded transition-colors duration-150" key={index}>
                                    <span className="text-blue-700 truncate flex-1 mr-2">{file.name}</span>
                                    <button 
                                      onClick={() => deleteFile(file)}
                                      className="p-1 text-red-600 hover:text-red-800 transition-colors duration-150 flex-shrink-0"
                                    >
                                      <img
                                        src={Delete}
                                        alt="supprimer"
                                        className="w-3 h-3"
                                      />
                                    </button>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/*footer*/}
              <div className="flex flex-shrink-0 items-center justify-end gap-3 rounded-b-2xl border-t border-solid border-gray-200 bg-white p-3">
                <button
                  className="flex min-h-11 flex-1 cursor-pointer items-center justify-center gap-2 rounded-xl bg-gray-100 px-4 py-2 text-sm font-semibold text-gray-500 transition-all duration-200 hover:bg-red-500 hover:text-white sm:flex-none"
                  type="button"
                  onClick={() => handleReset()}
                >
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  Annuler
                </button>
                <button
                  className="flex min-h-11 flex-1 cursor-pointer items-center justify-center gap-2 rounded-xl bg-green-600 px-4 py-2 text-sm font-semibold text-white shadow-lg transition-all duration-200 hover:bg-green-700 hover:shadow-xl sm:flex-none sm:hover:scale-105"
                  type="button"
                  onClick={handleCreateRequest}
                >
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                  </svg>
                  Créer la requête
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
      </>
    )
  );
};

export default ModalCreateRequest;
